const SEARCH_CLASSNAME = "js-off-canvas-search"
const TOGGLE_CLASSNAME = "js-off-canvas-search-toggle"

function offCanvasSearch() {
  const buttons = Array.from(document.getElementsByClassName(TOGGLE_CLASSNAME))
  const els = Array.from(document.getElementsByClassName(SEARCH_CLASSNAME))

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()

      els.forEach((el) => {
        el.classList.toggle("revealed")
        if (el.classList.contains("revealed")) {
          el.querySelector(".off-canvas-search__input").focus()
        }
      })
    })
  })
}

export default offCanvasSearch
